import { render } from "./Fields.vue?vue&type=template&id=05ededb0"
import script from "./Fields.vue?vue&type=script&lang=js"
export * from "./Fields.vue?vue&type=script&lang=js"
script.render = render

export default script